import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFlagIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 13 13",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
		d: "M2.32832 2.4375C2.69902 2.20391 2.94531 1.79004 2.94531 1.32031C2.94531 0.591602 2.35371 0 1.625 0C0.896289 0 0.304688 0.591602 0.304688 1.32031C0.304688 1.74434 0.502734 2.12012 0.8125 2.36133V2.4375V11.375V13H2.4375V11.375H11.9234C12.2941 11.375 12.5938 11.0754 12.5938 10.7047C12.5938 10.6107 12.5734 10.5193 12.5354 10.433L10.9688 6.90625L12.5354 3.37949C12.5734 3.29316 12.5938 3.20176 12.5938 3.10781C12.5938 2.73711 12.2941 2.4375 11.9234 2.4375H2.32832Z",
		fill: "currentColor"
	}) })
});
export default SvgFlagIcon;
